module.exports = __webpack_public_path__ + "img/icon-topper.8f1d6c9c.svg";